<template>
  <div
    class="fit-loading"
    :class="{
      'flex-center': !innerhidden,
      'loading-show': !innerhidden,
      'page-loading': innerpageLoading,
    }"
  >
    <div class="loading-cnt">
      <span v-if="innerlogo === 'default'" class="loading-logo"></span>
      <img v-if="innerlogo && innerlogo !== 'default'" class="loading-logo" :src="innerlogo" />
      <div class="loading-txt">{{ innertext }}</div>
      <span v-if="innerloadingIcon === 'default'" class="loading-icon"></span>
      <img v-if="innerloadingIcon && innerloadingIcon !== 'default'" class="loading-icon" :src="innerloadingIcon" />
    </div>
  </div>
</template>
<script>
import '../../themes/default/g.css';
import '../../themes/default/loading.css';
import base from '../../mixins/base.js';
export default {
  name: 'fit-loading',
  mixins: [base],
  props: {
    hidden: {
      type: Boolean,
      default: true,
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: 'WeChat Pay',
    },
    logo: {
      type: String,
      default: 'default',
    },
    loadingIcon: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      innerhidden: this.hidden,
      innerpageLoading: this.pageLoading,
      innertext: this.text,
      innerlogo: this.logo,
      innerloadingIcon: this.loadingIcon,
    };
  },
  methods: {
    hide() {
      this.innerhidden = true;
    },
    show(paramObj) {
      for (const key in paramObj) {
        if (this[`inner${key}`]) {
          this[`inner${key}`] = paramObj[key];
        }
      }
      this.innerhidden = false;
    },
  },
};
</script>
